module.exports = __webpack_public_path__ + "static/img/mihoutao.66c6be44.png";